import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export interface IParameters {
  queryStr: string;
  onMountHandler?: (queryValue: string | null) => void;
  onQueryChange?: (queryValue: string | null) => void;
}

export const useQueryParams = ({
  queryStr,
  onQueryChange,
  onMountHandler,
}: IParameters) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryValue = searchParams.get(queryStr);

  const handleChange = useCallback(
    (value: string, needUpdate: boolean) => {
      if (searchParams.has("p") && queryStr !== "p") {
        searchParams.delete("p");
      }
      if (!needUpdate) {
        return;
      }
      if (value) {
        if (searchParams.has(queryStr)) {
          searchParams.set(queryStr, value);
        } else {
          searchParams.append(queryStr, value);
        }

        setSearchParams(searchParams);
      } else {
        searchParams.delete(queryStr);
        setSearchParams(searchParams);
      }
    },
    [queryStr, searchParams, setSearchParams],
  );

  useEffect(() => {
    if (searchParams.get(queryStr)) {
      onMountHandler && onMountHandler(searchParams.get(queryStr));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onQueryChange && onQueryChange(searchParams.get(queryStr));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryValue]);

  return { handleChange, queryValue: searchParams.get(queryStr) };
};
